"use client";
import { CargandoContextType } from "@/interfaces";
import { createContext, useState, useContext } from "react";

export const CargandoContext = createContext<CargandoContextType>({
  cargando: false,
  empezarCarga: () => {},
  terminarCarga: () => {},
});

// eslint-disable-next-line react/prop-types
export const CargandoProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [cargando, setCargando] = useState(false);
  const empezarCarga = () => setCargando(true);
  const terminarCarga = () => setCargando(false);

  return (
    <CargandoContext.Provider
      value={{
        cargando,
        empezarCarga,
        terminarCarga,
      }}
    >
      {children}
    </CargandoContext.Provider>
  );
};

export const useCargando = () => useContext(CargandoContext);
